import React from "react";
import { GrantItem } from "./GrantItem";
import { gapAppUrl, getGapProjectGrantUrl } from "../../api/gap";
import { Flex, Link, Text } from "@chakra-ui/react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const GrantList = _ref => {
  let {
    grants,
    displayKarmaAttribution = true
  } = _ref;
  return /*#__PURE__*/_jsxs(Flex, {
    gap: 2,
    flexDir: "column",
    py: 6,
    px: 3,
    children: [/*#__PURE__*/_jsx("h4", {
      className: "text-3xl",
      children: "Project milestones"
    }), grants.length > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Text, {
        className: "text-[18px]",
        children: ["Total grants (", grants.length, ")"]
      }), grants.map((grant, index) => /*#__PURE__*/_jsx(GrantItem, {
        grant: grant,
        url: getGapProjectGrantUrl(grant.projectUID, grant.uid)
      }, +index)), displayKarmaAttribution && /*#__PURE__*/_jsxs(Text, {
        fontFamily: "DM Mono",
        textAlign: "center",
        className: "text-xs",
        children: ["Data provided by Karma via", " ", /*#__PURE__*/_jsx(Link, {
          href: gapAppUrl,
          target: "_blank",
          children: /*#__PURE__*/_jsx(Text, {
            as: "span",
            className: "text-gitcoin-violet-500",
            children: "gap.karmahq.xyz"
          })
        }), "."]
      })]
    }) : /*#__PURE__*/_jsxs(Text, {
      children: ["No previous grants are being tracked for this project. If you're the owner of this project, visit", " ", /*#__PURE__*/_jsx(Link, {
        target: "_blank",
        href: gapAppUrl,
        children: /*#__PURE__*/_jsx(Text, {
          as: "span",
          className: "text-gitcoin-violet-500",
          children: "gap.karmahq.xyz"
        })
      }), " ", "to add your project and post updates."]
    })]
  });
};